// Chapter 10 writing frames ("מסגרות"), uploaded 1.11.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch10_fN"> in src/chapters/chapter-10.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH10_FRAMES: Frame[] = [
  {
    "id": "ch10_f1",
    "n": "10.1",
    "title": "הדבר שאני דוחה",
    "type": "lines",
    "intro": "עובדות בלבד, בלי שיפוט. אין תשובה נכונה.",
    "fields": [
      "השם שנתתי לו:",
      "כמה זמן אני דוחה את זה (שבועות / חודשים):",
      "אם זה ייכשל, מה זה יגיד עליי (לדעת האגו):",
      "סכנת מוות? (כן / לא) ומה באמת יכול לקרות:"
    ]
  },
  {
    "id": "ch10_f2",
    "n": "10.2",
    "title": "האגו שלי על הסרגל",
    "type": "scale2",
    "intro": "1 = ביטול עצמי (לרצות, לשתוק), 10 = הרס עצמי (להילחם, להיות צודקת). 5-6 = מאוזן.",
    "fields": [
      "איפה האגו שלי בדבר שאני דוחה",
      "מה באמת חשוב כאן (לא מה יחשבו):"
    ]
  },
  {
    "id": "ch10_f3",
    "n": "10.3",
    "title": "על מי אני כועסת",
    "type": "lines",
    "intro": "",
    "fields": [
      "על מי אני כועסת בעניין הזה (על מישהו / על עצמי / על שניהם):",
      "הפרשנות שיושבת מתחת לכעס (מה אני מספרת לעצמי):"
    ]
  },
  {
    "id": "ch10_f4",
    "n": "10.4",
    "title": "האריה שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "כשאני מסתכלת על האריה שלי ישר, מה אני רואה (עובדות):",
      "מה הוא עושה כשאני לא בורחת:",
      "שתי הדקות שלי היום (רק לעמוד מולו, בלי לפתור):"
    ]
  },
  {
    "id": "ch10_f5",
    "n": "10.5",
    "title": "מה הסוס קורא בי",
    "type": "lines",
    "intro": "",
    "fields": [
      "מה הסוס היה קורא בי בדרך לדבר הזה (מפוחדת / מהססת / נחושה / נרגשת):",
      "מה בשפת הגוף שלי מסגיר אותי:",
      "שקית הניילון שלי (הפרט הקטן שמפחיד יותר מהדבר עצמו):"
    ]
  },
  {
    "id": "ch10_f6",
    "n": "10.6",
    "title": "שני סיכונים",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "הסיכון בלעשות את זה|הסיכון בלדחות עוד חודש",
      "כמה פעמים כבר ניגשתי וירדתי, והמשפט בראש ברגע הירידה:"
    ]
  },
  {
    "id": "ch10_f7",
    "n": "10.7",
    "title": "מי קורא אותי",
    "type": "lines",
    "intro": "",
    "fields": [
      "מי קורא אותי כמו סוס (ורואה את הדחייה לפניי):",
      "מה הוא או היא כנראה רואים:",
      "למי אספר על הדבר הזה השבוע:"
    ]
  },
  {
    "id": "ch10_f8",
    "n": "10.8",
    "title": "השרשרת, והמדרגה הראשונה",
    "type": "lines",
    "intro": "",
    "fields": [
      "סוג ההימנעות שלי (התנהגותית / קוגניטיבית / רגשית / חברתית):",
      "השרשרת שלי, עד הסוף: לא ... ← ... ← ...",
      "הצעד הכי קטן למחר, כזה שהגוף לא יזהה כאיום:"
    ]
  },
  {
    "id": "ch10_f9",
    "n": "10.9",
    "title": "הרגש, והעשר דקות",
    "type": "choice5",
    "intro": "סמני אחד, ואז שורה אחת:",
    "fields": [
      "חרדת ביצוע · פחד מכישלון · תסכול · בושה · כעס",
      "הדבר הגרוע ביותר שיכול לקרות:"
    ]
  },
  {
    "id": "ch10_f10",
    "n": "10.10",
    "title": "סליחה, ושותפות",
    "type": "lines",
    "intro": "",
    "fields": [
      "משפט הסליחה שלי על הדחייה (בלי \"אבל\"):",
      "מה הדחייה ניסתה להגן עליי ממנו (ולמה זה כבר לא משרת אותי):",
      "שותף או שותפת האחריות שלי, ומתי שואלים אותי \"עשית?\":"
    ]
  },
  {
    "id": "ch10_f11",
    "n": "10.11",
    "title": "הדבר שלי, מתוך בחירה",
    "type": "final",
    "intro": "",
    "fields": [
      "שאלתי שוב \"יש כאן סכנת מוות?\" והתשובה היום, אחרי עשרה צעדים:",
      "שלושה דברים טובים מהיום:",
      "",
      "",
      "10 הדקות הראשונות שלי: יום, שעה, ומה בדיוק:",
      "מה אגיד לעצמי כשאסיים אותן:"
    ]
  }
];
